import { Link } from "react-router-dom";

const SIZES = {
  nav: "h-[13px] sm:h-[15px] md:h-[18px]",
  lg: "h-6 md:h-8",
  bar: "h-4 sm:h-6 md:h-8",
  footer: "h-[9vw] md:h-[6.5vw]",
};

/** The KICKSTARTKENYAFOOTBALL wordmark, used everywhere the brand appears. */
export const Wordmark = ({ size = "nav", to = "/", testId = "wordmark", lockup = false }) => {
  const src = lockup ? "/brand/kskf-lockup-white.png" : "/brand/kskf-wordmark-white.png";
  const mark = (
    <img
      src={src}
      alt="KickStartKenyaFootball"
      className={`w-auto select-none ${SIZES[size] || SIZES.nav}`}
      data-testid={testId}
      draggable="false"
    />
  );

  if (!to) return mark;
  return (
    <Link to={to} className="group inline-block" data-testid={`${testId}-link`}>
      {mark}
    </Link>
  );
};
